import { getServerErrorByCode } from 'Config/server-error-messages';
import { isArray, isString, upperFirst } from 'Utils/common';

export default class HttpClientError extends Error {
  constructor(response) {
    super(response.statusText);
    this.response = response;
  }

  getServerErrorText() {
    const errors = this.response.data;
    let message = '';
    const serverErrorByCode = getServerErrorByCode(errors.code);
    if (serverErrorByCode) {
      message = serverErrorByCode;
    } else if (errors.__error__) {
      const { __error__ } = errors;
      if (isArray(__error__)) {
        message = __error__.map(er => upperFirst(er)).join(', ');
      } else {
        message = __error__.statusDesc || JSON.stringify(__error__).replace(/"/g, '');
      }
    } else if (errors.error || errors.result || errors.message || isString(errors)) {
      message = upperFirst(errors.error || errors.result || errors.message || errors);
    }
    return message;
  }
}
